/** Role of an additional contact inside a CRM account (E2 RF-01). Mirrors the backend enum. */
export enum CustomerContactRoleEnum {
  DECISION_MAKER = 'DECISION_MAKER',
  FINANCE = 'FINANCE',
  TECHNICAL = 'TECHNICAL',
  OTHER = 'OTHER',
}
